var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9555 9.82617C9.47463 9.82617 9.08594 10.1371 9.08594 10.5218V16.087C9.08594 16.4717 9.47463 16.7827 9.9555 16.7827C10.4364 16.7827 10.8251 16.4717 10.8251 16.087V10.5218C10.8251 10.1371 10.4364 9.82617 9.9555 9.82617Z",
    fill: "#73007D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3071 9.82617C13.8262 9.82617 13.4375 10.1371 13.4375 10.5218V16.087C13.4375 16.4717 13.8262 16.7827 14.3071 16.7827C14.7879 16.7827 15.1766 16.4717 15.1766 16.087V10.5218C15.1766 10.1371 14.7879 9.82617 14.3071 9.82617Z",
    fill: "#73007D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.413 2H9.84783C9.00859 2 8.32609 2.69 8.32609 3.53846V5.07692H6.04348H3.76087C3.34011 5.07692 3 5.42077 3 5.84615C3 6.27154 3.34011 6.61538 3.76087 6.61538H5.28261V19.6923C5.28261 20.9646 6.30674 22 7.56522 22H16.6957C17.9541 22 18.9783 20.9646 18.9783 19.6923V6.61538H20.5C20.9208 6.61538 21.2609 6.27154 21.2609 5.84615C21.2609 5.42077 20.9208 5.07692 20.5 5.07692H18.2174H15.9348V3.53846C15.9348 2.69 15.2523 2 14.413 2ZM17.4565 19.6923C17.4565 20.1169 17.1157 20.4615 16.6957 20.4615H7.56522C7.14522 20.4615 6.80435 20.1169 6.80435 19.6923V6.61538H17.4565V19.6923ZM9.84783 5.07692V3.53846H14.413V5.07692H9.84783Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5f38c88168baeb0dcb27eff9f393fa79.svg";
export { ForwardRef as ReactComponent };